
<div class="ui-g">
  <!-- Button Torna Indietro -->
  <div class="ui-g-12 text-right">
    <button
      pButton
      type="button"
      class="k-generic-btn"
      icon="fa fa-angle-left"
      iconPos="left"
      label="{{ 'common.back' | translate }}"
      (click)="backToCustomer()">
    </button>
  </div>
  <div class="ui-g-12">
    <h1>{{ 'customers.mgLinkCardTitle' | translate }}</h1>
  </div>
  <div class="ui-g-12" *ngIf="!isChild">
    <!-- Input Ricerca Carta Figlia -->
    <div class="ui-g-12 ui-md-4">
      <p class="label">{{ 'customers.searchChildCard' | translate }}</p>
      <input id="child-card-input" type="text" style="width: calc(100% - 33px) !important;" [disabled]="true" pInputText class="inputSelect" [(ngModel)]="selectedChildCardNumber" placeholder="{{'pointTransfer.selectCardPlaceholder' | translate}}" />
      <p-button style="margin-left: -5px;" pTooltip="{{ 'common.select' | translate }}" icon="fa fas fa-arrow-circle-right"  styleClass="selectButtonArrow ui-button-info" (onClick)="openSelectChildCardDialog()"></p-button>
    </div>
  </div>
  <div class="ui-g-12" *ngIf="!isChild">
    <!-- Switch Collega Tessera -->
    <div class="ui-g-12 ui-md-6">
      <p>{{ 'customers.connectCard' | translate }}</p>
      <p-inputSwitch [(ngModel)]="switchValue" [disabled]="true"></p-inputSwitch>
    </div>
    <!-- Switch Trasferisci Saldi -->
    <div class="ui-g-12 ui-md-6">
      <p>{{ 'customers.transferBalances' | translate }}</p>
      <p-inputSwitch [(ngModel)]="switchValue" [disabled]="true"></p-inputSwitch>
    </div>
  </div>
  <div class="ui-g-12" *ngIf="!isChild">
    <!-- Button Salvataggio -->
    <div class="ui-g-12" >
      <button
        pButton
        [disabled]="!selectedChildCardNumber"
        type="button"
        class="k-generic-btn"
        icon="fa fa-floppy-o"
        iconPos="left"
        label="{{ 'common.save' | translate }}"
        (click)="linkCard()">
      </button>
      <!-- Button visualizzazione Storico completo
      <button
        pButton
        type="button"
        class="k-generic-btn"
        icon="fa fa-floppy-o"
        iconPos="left"
        label="{{ 'customers.historical' | translate }}"
        (click)="getChildCards(true)">
      </button>-->
    </div>
  </div>
  <div class="ui-g-12">
    <!-- Lista Carte Collegate -->
    <app-kontable
      #childCardsTable
      title="{{ 'customers.childCards' | translate }}"
      [columns]="[
        'cartaCollegata',
        'cartaMaster',
        {field: 'dataCollegamento', title: 'customers.connectionDate', type: 'date', filterType: dateFilter}]"
      [titles]="['customers.childCard', 'customers.parentCard']"
      [source]="childCards"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="false"
      [showGlobalFilter]="false"
      [showInfoButton]="false"
      [showReport]="false"
      [showEditButton]="false"
      [showDeleteButton]="false"
      [additionalRowCommands]="customBtnRow">
      <!-- Bottoni custom -->
      <ng-template #customBtnRow data-testid="customBtnRow" let-row>
        <!-- Unlink Button -->
        <p-button
          *ngIf="row.blackList === '0'"
          pTooltip="{{ 'card.unlink_card' | translate }}"
          icon="fa fas fa-unlink"
          styleClass="ui-button-info"
          (onClick)="unlinkCard(row)">
        </p-button>
      </ng-template>
    </app-kontable>
  </div>
</div>
<!-- Modale Selezione Carta Figlia -->
<p-dialog
  [(visible)]="showChildCardSelectionDialog"
  header="{{ 'card.select_card' | translate }}"
  [responsive]="true"
  showEffect="fade"
  [modal]="true">
  <app-card-selection-table
    [flgBlkLst]="'0'"
    *ngIf="showChildCardSelectionDialog"
    (onCardSelect)="onChildCardSelected($event)">
  </app-card-selection-table>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/loyaltyinfo/components/mg-link-card/mg-link-card.component.html